import { render, staticRenderFns } from "./costPerService.vue?vue&type=template&id=e8d29ffe&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./costPerService.vue?vue&type=style&index=0&id=e8d29ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d29ffe",
  null
  
)

export default component.exports